import loadable from "@loadable/component";
export * from "./Editor";
export { default as useEditorRef } from "./useEditorRef";
export const Editor = loadable(()=>import("./Editor"));
